import { Route } from '@angular/router';
import { IsLoggedInGuard, RequiresPermissionGuard } from '@lexplus-authentication';
import { LOCALIZED_USER_ROUTES, USER_ROUTES_IDS } from '../../localized-user-routes-const';
import { UserDetailDrawerRoute } from '../../global/functions/user-detail-drawer-route.function';
import { DOKUMENTEN_MANAGER_PERMISSION } from './functions/build-dokument-detail-drawer-type.function';

/**
 * The routes of the Dokumenten Manager page including their guards.
 *
 * The detail drawer is a **nested** child of the overview: that nesting is what keeps the
 * overview mounted behind the drawer, so closing it restores the list and its scroll
 * position instead of reloading the page. Other pages mount the same drawer the same way —
 * see {@link UserDetailDrawerRoute}.
 *
 * @param {string} localeId - The language ID that determines the localized routes
 * @returns {Route} The Dokumenten Manager page's route with its child routes
 */
export function DokumentenManagerPageRoute(localeId: string): Route {
  const locale = localeId?.split('-')[0] || 'en';

  return {
    path: '',
    canActivate: [IsLoggedInGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOCUMENT_MANAGER][locale],
      },
      {
        path: LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.USER_DOCUMENT_MANAGER][locale],
        loadComponent: () =>
          import('./pages/dokumenten-manager-page/dokumenten-manager-page.component').then((m) => m.DokumentenManagerPageComponent),
        canActivate: [IsLoggedInGuard, RequiresPermissionGuard],
        data: { routeId: USER_ROUTES_IDS.USER_DOCUMENT_MANAGER, requiredPermission: DOKUMENTEN_MANAGER_PERMISSION },
        children: [
          UserDetailDrawerRoute(
            'dokument',
            LOCALIZED_USER_ROUTES[USER_ROUTES_IDS.DETAILS][locale],
            USER_ROUTES_IDS.USER_DOCUMENT_MANAGER,
            locale,
          ),
        ],
      },
    ],
  };
}
